<!-- 
Satisfies:
    -  a user-friendly, functional dashboard that includes three visualization types (2 of 3)

This script implements the projection of our kmeans PCA chart and our kmeans Silhouette score
chart. The user can navigate to this page to view the data and navigate back to the previous
page when finished.
-->
<script setup>
const backend_url = import.meta.env.VITE_API_URL;

const goBack = () => {
    if(window.history.length > 1){
        window.history.back();
    }
    else{
        window.location.hash = '#/login';
    }
}
</script>

<template>
    <v-container>
        <v-btn variant="text" prepend-icon="mdi-arrow-left" @click="goBack">
            Back to Recommendations
        </v-btn>

        <h2>Game Clusters (PCA Projection)</h2>
        <v-img :src="`${backend_url}/api/static-data/cluster_plot.png`"/>

        <h2>Silhouette Score by k</h2>
        <v-img :src="`${backend_url}/api/static-data/silhouette_plot.png`"/>
    </v-container>
</template>